import { Injectable } from '@angular/core';
import { ClaimType } from '../../shared/models/claim-type';
import { BaseWithIdList} from '../../shared/models/list';
import { Observable } from 'rxjs';
import {
  BaseHttpService, Query, UriBuilderParams } from '@app/core/services/base/base-http.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { map } from 'rxjs/operators';

export class ClaimTypeUriBuilderParams extends UriBuilderParams<ClaimType> {

  constructor(claimType?: ClaimType | string) {
    super(claimType);
  }

  public buildUri(): string {
    return this.simpleUriBuild(BackendUriUnits.CLAIM_TYPES);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ClaimTypeService extends BaseHttpService<ClaimType, ClaimTypeUriBuilderParams>
                              implements Query<ClaimType, ClaimTypeUriBuilderParams> {

  constructor(httpServiceBundle: HttpServiceBundle) {
    super(ClaimType, httpServiceBundle);
  }

  // BASE METHODS ****************************************************************************************

  public query(uriParams: ClaimTypeUriBuilderParams, params?: any): Observable<BaseWithIdList<ClaimType>> {
    return this.queryBase(uriParams, params)
               .pipe(map(result => {
       const list = BaseWithIdList.upgradeFromBaseList(result);
       list.items.sort((a, b) => (a.displayName > b.displayName) ? 1 : -1);
       return list;
     }));
  }

}
